import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ChatroomFormModal from "./ChatroomFormModal";
import ChatroomTypeFilter from "./ChatroomTypeFilter";
import ActiveChatroomFilter from "./ActiveChatroomFilter";

class ChatroomHeader extends React.Component {
  state = {
    visible: false,
    chatroomTypeFilter: this.props.chatroomTypeFilter,
    activeChatroomFilter: this.props.activeChatroomFilter
  };

  render() {
    const {
      visible,
      chatroomTypeFilter,
      activeChatroomFilter
    } = this.state;

    const {
      currentUser,
      chatroomTypes,
      addChatroom,
      userOptions,
      locationOptions,
      positionOptions,
      locationId,
      positionId,
      changeChatroomTypeFilter,
      changeActiveChatroomFilter
    } = this.props;

    return (
      <div className="row chatroom-header">
        <div className="col-md-3">
          <ChatroomTypeFilter
            chatroomTypeFilter={chatroomTypeFilter}
            chatroomTypes={chatroomTypes}
            changeChatroomTypeFilter={changeChatroomTypeFilter}
            selectClassName={""}
          />
        </div>
        <div className="col-md-3">
          {currentUser.admin &&
            <ActiveChatroomFilter
              activeChatroomFilter={activeChatroomFilter}
              changeActiveChatroomFilter={changeActiveChatroomFilter}
              selectClassName={""}
            />
          }
        </div>
        <div className="col-md-3">
        </div>
        <div className="col-md-3">
          {currentUser.admin &&
            <a
              href="javascript:void(0);"
              className="btn btn-pink btn-block btn-raised"
              onClick={this.handlerToggleModal}
            >
              ADD CHAT
            </a>
          }
        </div>

        <ChatroomFormModal
          visible={visible}
          currentUser={currentUser}
          chatroomTypes={chatroomTypes}
          addChatroom={addChatroom}
          handlerToggleModal={this.handlerToggleModal}
          title={"Add Chat"}
          newChatroom={true}
          userOptions={userOptions}
          locationOptions={locationOptions}
          positionOptions={positionOptions}
          locationId={locationId}
          positionId={positionId}
        />
      </div>
    );
  }

  handlerToggleModal = () => this.setState({visible: !this.state.visible});
}

ChatroomHeader.propTypes = {
  addChatroom: PropTypes.func,
  currentUser: PropTypes.object,
  chatroomTypes: PropTypes.array,
  userOptions: PropTypes.array,
  locationOptions: PropTypes.array,
  positionOptions: PropTypes.array,
  locationId: PropTypes.number,
  positionId: PropTypes.number
};

export default ChatroomHeader;
